import USER_ROLES from 'shared/src/domain/user-roles';
import { AuthProfile } from './auth-profile';

export class AuthorizationRules {
    static canBuild(user: AuthProfile): boolean {
        return user.roles.includes(USER_ROLES.MAPPING_ADMIN);
    }
}
